import React, { useRef, useState, useEffect } from 'react';
import { isEmpty, getFormatNumPlus } from '@gp/utils/common';

import type { IBaseProps } from '@home/types/common';

import './index.scss';

interface IRangeTdProps extends IBaseProps {
  text1?: number | null;
  text2?: number | null;
}

const ROW_HEIGHT = 20;

const COMMON_STYLE = {
  lineHeight: `${ROW_HEIGHT}px`,
};

function useIsWrap(node: React.RefObject<HTMLElement>, props?: {
  isNoData?: boolean;
  text1?: string;
  text2?: string;
}) {
  const { isNoData, text1, text2 } = props || {};

  const [isWrap, setIsWrap] = useState(false);

  useEffect(() => {
    if (isNoData || !node?.current) {
      setIsWrap(false);
      return;
    }

    setIsWrap(node.current.clientHeight > ROW_HEIGHT);
  }, [isNoData, text1, text2]);

  return isWrap;
}

// 显示区间数据，显示不下换行展示
const RangeTd: React.FC<IRangeTdProps> = (props) => {
  const { text1 = null, text2 = null } = props;

  const isNoDataText1 = isEmpty(text1);
  const isNoDataText2 = isEmpty(text2);
  const isNoData = isNoDataText1 && isNoDataText2;

  const text1Formatted = isNoDataText1 ? '-' : getFormatNumPlus(text1 as number, 2, false);
  const text2Formatted = isNoDataText2 ? '-' : getFormatNumPlus(text2 as number, 2, false);

  const container = useRef<HTMLElement>(null);
  const isWrap = useIsWrap(container, { isNoData, text1: text1Formatted, text2: text2Formatted });

  return (
    <>
      {/* text1、text2都无数据 */}
      {isNoData && (
        <section ref={container} className="dbg-studio-overall-projects-dev-overview-table-td-range-item dbg-range-id">
          <i style={COMMON_STYLE} className="dbg-studio-overall-projects-dev-overview-table-td-wavy-line dbg-range-id__spliter">-</i>
        </section>
      )}
      {/* 有数据，但是内容超出了，展示为两行 */}
      {!isNoData && (
        <section ref={container} className="dbg-studio-overall-projects-dev-overview-table-td-range-item dbg-range-id">
          <span style={COMMON_STYLE} className="dbg-studio-overall-projects-dev-overview-table-td-range-item-text dbg-range-id__text" title={text1Formatted}>
            {text1Formatted}
          </span>
          <i style={COMMON_STYLE} className="dbg-studio-overall-projects-dev-overview-table-td-wavy-line dbg-range-id__spliter">-</i>
          <span style={COMMON_STYLE} className="dbg-studio-overall-projects-dev-overview-table-td-range-item-text dbg-range-id__text" title={text2Formatted}>
            {text2Formatted}
          </span>
          {/* 换行时，展示最后一个-，配合第一行最后的-，视觉上最小值，最大值 右对齐 */}
          {isWrap && <i style={{ ...COMMON_STYLE, visibility: 'hidden' }} className="dbg-studio-overall-projects-dev-overview-table-td-wavy-line dbg-range-id__spliter">-</i>}
        </section>
      )}
    </>
  );
};

export default React.memo(RangeTd);
